import { Dropdown } from 'react-bootstrap';

const ActionDropdownItems = () => {
  return (
    <>
      <Dropdown.Item eventKey="1" disabled>View</Dropdown.Item>
      <Dropdown.Item eventKey="2" disabled>Edit</Dropdown.Item>
      <Dropdown.Item eventKey="3" disabled>Export</Dropdown.Item>
      <Dropdown.Divider />
      <Dropdown.Item eventKey="4" disabled className="text-danger">
        Remove
      </Dropdown.Item>
    </>
  );
};

export default ActionDropdownItems;
